import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/brand-protection-guide/[platform]/BrandProtectionGuidePlatform.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
